exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header_3cvpQ {\n    height: 80px;\n    width: 100%;\n}\n\n.sectionHeader_B8Onq {\n    display: inline-block;\n    height: 100%;\n}\n\n.sectionName_17pXZ {\n    display: inline-block;\n    vertical-align: middle;\n}\n\n.sectionName_17pXZ > h3 {\n    margin-bottom: 0;\n    border-bottom: 2px solid #b2b2b2;\n}\n\n.sectionName_17pXZ > p {\n    text-align: center;\n}\n\n.sectionHeader_B8Onq img {\n    height: 80px;\n}\n\n.sectionHeader_B8Onq small {\n    font-size: 10px;\n}\n\n.footerWrap_P9aiw {\n    font-size: 16px;\n}\n\n.footerWrap_P9aiw p {\n    margin: 0;\n}\n\n.footerDescription_1L2ES {\n    font-style: italic;\n    margin-right: 50px;\n}\n\n.footerLeft_3Grsm {\n    width: 50%;\n    display: inline-block;\n    font-size: 12px;\n}\n\n.footerRight_3zz7A {\n    width: 50%;\n    display: inline-block;\n    text-align: right;\n    font-size: 12px;\n}\n\n.footerBold_m021X {\n    font-weight: bold;\n    padding-left: 3px;\n    font-size: 13px;\n}\n", ""]);

// exports
exports.locals = {
	"header": "header_3cvpQ",
	"sectionHeader": "sectionHeader_B8Onq",
	"sectionName": "sectionName_17pXZ",
	"footerWrap": "footerWrap_P9aiw",
	"footerDescription": "footerDescription_1L2ES",
	"footerLeft": "footerLeft_3Grsm",
	"footerRight": "footerRight_3zz7A",
	"footerBold": "footerBold_m021X"
};